export interface KeyphraseRow {
	pronoun?: string;
	maxWordAllowance: number;
	terms: string;
	tag: string;
	matchWholeWords?: boolean;
	errorFields?: Record<string, string[]>;
}

export const EMPTY_ROW: KeyphraseRow = {
	pronoun: '',
	maxWordAllowance: 0,
	terms: '',
	tag: '',
	errorFields: {},
};

// export const testRows = [
// 	{
// 		pronoun: '',
// 		maxWordAllowance: 0,
// 		terms: 'i am active',
// 		tag: 'contact',
// 	},
// 	{
// 		pronoun: 'my',
// 		maxWordAllowance: 1,
// 		terms: 'girl',
// 		tag: 'access',
// 		matchWholeWords: false,
// 	},
// 	{
// 		pronoun: '',
// 		maxWordAllowance: 0,
// 		terms: 'perverted',
// 		tag: 'contact',
// 		matchWholeWords: true,
// 	},
// 	{
// 		pronoun: '',
// 		maxWordAllowance: 0,
// 		terms: 'Kill yourself',
// 		tag: 'Grooming',
// 		matchWholeWords: true,
// 	},
// 	{
// 		pronoun: 'up',
// 		maxWordAllowance: 1,
// 		terms: 'skirt',
// 		tag: 'Fantasy',
// 		matchWholeWords: true,
// 	},
// ];

const INITIAL_TAG_OPTIONS = ['access', 'contact'];

const addError = (errs: Record<string, string[]>, field: string, err: string) => {
	if (field in errs) {
		// ensures uniqueness in errors
		errs[field] = Array.from(new Set([...errs[field], err]));
	} else {
		errs[field] = [err];
	}
};

export const validateRow = (row: KeyphraseRow): Record<string, string[]> => {
	const errorFields: Record<string, string[]> = {};

	if (!row.pronoun && row.maxWordAllowance > 0) {
		addError(errorFields, 'pronoun', 'A pronoun must be supplied if "Max Word Allowance" is greater than 0');
	}

	if (row.maxWordAllowance < 0) {
		addError(errorFields, 'maxWordAllowance', 'Max Word Allowance must be 0 or greater');
	}

	if (!row.terms || row.terms.length === 0) {
		addError(errorFields, 'terms', '"Terms" must contain at least one letter');
	}

	if (!row.tag) {
		addError(errorFields, 'tag', 'A tag must be supplied');
	}

	return errorFields;
};

export const convertRowsToCSV = (rows: KeyphraseRow[]): string => {
	let fullCSV = '';

	if (rows && rows.length > 0) {
		rows.forEach((row) => {
			const curRow: string[] = [];
			if (row.pronoun) {
				curRow.push(row.pronoun);
			} else {
				curRow.push('');
			}
			curRow.push(row.maxWordAllowance.toString());
			curRow.push(row.terms);
			curRow.push(row.tag);
			if (row.matchWholeWords) {
				curRow.push('TRUE');
			} else {
				curRow.push('FALSE');
			}

			fullCSV += `${curRow.join(',')}\n`;
		});
	} else {
		throw new Error('No rows supplied, cannot convert to CSV');
	}

	return fullCSV;
};

export const convertCSVToRows = (csv: string): KeyphraseRow[] => {
	let rows: KeyphraseRow[] = [];

	const splitRows = csv.replaceAll('\r', '').split('\n');
	if (splitRows.length > 1) {
		rows = splitRows
			.slice(1)
			.filter((row) => row)
			.map((row) => {
				const splitRow = row.split(',');
				const newRow = {
					pronoun: splitRow[0] ? splitRow[0].trim() : '',
					maxWordAllowance: splitRow[1] ? parseInt(splitRow[1]) : 0,
					terms: splitRow[2] ? splitRow[2].trim() : '',
					tag: splitRow[3] ? splitRow[3].trim() : '',
					matchWholeWords: splitRow[4] ? (splitRow[4].toLocaleLowerCase() === 'true' ? true : false) : false,
				};
				return newRow;
			});
	} else {
		throw new Error('Keyphrases list did not have any lines, cannot generate rows');
	}

	return rows;
};

export const convertWordsToRows = (words: string[]): KeyphraseRow[] => {
	let rows: KeyphraseRow[] = [];

	if (words.length > 0) {
		rows = words
			.filter((row) => row)
			.map((row) => {
				return {
					pronoun: '',
					maxWordAllowance: 0,
					terms: row,
					tag: '',
					matchWholeWords: false,
				};
			});
	}

	return rows;
};

export const createInitialTags = (rows: KeyphraseRow[]): string[] => {
	const tags = new Set(INITIAL_TAG_OPTIONS);
	rows.forEach((row) => {
		if (row.tag) {
			tags.add(row.tag);
		}
	});
	return Array.from(tags);
};
